export default __webpack_public_path__ + "geburtstag-chat-02.8692615827014f5e7575e0558b40eda6.png";